import { Pipe, PipeTransform } from '@angular/core';
import { DashboardCustomer } from '../../../api/models'

@Pipe({
  name: 'flowTotal'
})
export class FlowTotalPipe implements PipeTransform {


  /**
   * Calculate the total flow max or current of all meter details
   * @param meterDetails 
   * @param calculateTotal
   */
  transform(meterDetails: DashboardCustomer[], calculateCurrent: boolean = false): number {
    let total = 0;

    meterDetails.forEach(customer => {
      customer.valveMeters.forEach(customer => {
        if (calculateCurrent) {
          total += customer.deviceInFlowRate.value
        } else {
          total += parseInt(customer.maximumFlowRate)
        }
      })
    })
    
    return total;
  }

}
